module.exports = __webpack_public_path__ + "files/3a88bc2e06899d050d19870124c92079.png";